import styled, { css } from 'styled-components'

export const SelectContainer = styled.div<{ error?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
  position: relative;
  z-index: 10;
  span {
    font-size: 12px;
    color: ${({ theme }) => theme.colors.primary};
    transition: all 0.3s ease-in-out;
  }

  .select-input {
    height: 20px;
    background: transparent;
    outline: none;
    border-width: 0 0 2px;
    border-color: ${({ theme }) => theme.colors.primary};
    font-size: 16px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.white};
    cursor: text;

    ${({ error }) =>
      error &&
      css`
        border-color: ${({ theme }) => theme.colors.red};
      `}
  }

  .options {
    flex-direction: column;
    gap: 10px;
    width: 100%;
    background: transparent;
    height: 0;
    display: none;
    transition: all 0.5s ease-in-out;
    overflow: auto;

    &.open {
      display: flex;
      height: fit-content;
      max-height: 150px;
    }

    button {
      all: unset;
      color: white;
      font-size: 12px;
      padding: 10px;
      cursor: pointer;
      transition: all 0.5s ease-in-out;

      &:hover {
        background-color: ${({ theme }) => theme.colors.darkOpacity};
      }
    }

    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.colors.darkOpacity};
      border-radius: 10px;
      height: 4px;
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid ${({ theme }) => theme.colors.primary};
    right: 0.5rem;
    top: 1.5rem;
  }
`
export const Error = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.red};
`
